/**
 * Light/dark mode pairing for the global theme toggle.
 * Pure helpers — no React. The pair: Operator Dark <-> Clean Enterprise.
 */

export type ThemeMode = "light" | "dark";

export const MODE_THEME_IDS: Record<ThemeMode, string> = {
  dark: "operator-dark",
  light: "clean-enterprise",
};

/** Cross-context sync (App shell -> Designer shell) */
export const THEME_MODE_EVENT = "softlavka:theme-mode-changed";

export function themeIdForMode(mode: ThemeMode): string {
  return MODE_THEME_IDS[mode];
}

export function getPreferredColorScheme(): ThemeMode {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return "light";
  }
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function emitThemeMode(mode: ThemeMode): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent<ThemeMode>(THEME_MODE_EVENT, { detail: mode }));
}
